import React from 'react';
import { cx } from '../../../../../ui/components/cx';
import './SwitchField.scss';

export interface SwitchFieldProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id: string;
  label: React.ReactNode;
}

/**
 * Labelled on/off switch (Bootstrap form-switch markup, restyled by bridge.scss).
 * All input props (name, checked, onChange, disabled, title) pass straight to the checkbox.
 */
const SwitchField: React.FC<SwitchFieldProps> = ({ id, label, className, disabled, ...rest }) => (
  <div className={cx('tp-switch-field', disabled && 'tp-switch-field--disabled', className)}>
    <label className="tp-switch-field__label form-check-label" htmlFor={id}>{label}</label>
    <div className="form-check form-switch tp-switch-field__control">
      <input id={id} type="checkbox" role="switch" className="form-check-input" disabled={disabled} {...rest} />
    </div>
  </div>
);

export default SwitchField;
